import type { ReactNode } from 'react';

export interface CardProps {
  variant?: 'default' | 'dark';
  /** 'lg' applies large padding; false leaves padding to the child (tables, lists). */
  padding?: 'lg' | false;
  className?: string;
  children: ReactNode;
}

export function Card({ variant = 'default', padding = 'lg', className = '', children }: CardProps) {
  const cls = [
    'tr-card',
    variant === 'dark' && 'tr-card--dark',
    padding === 'lg' && 'tr-card--pad-lg',
    className,
  ]
    .filter(Boolean)
    .join(' ');
  return <div className={cls}>{children}</div>;
}
